import CardBody from 'components/card/CardBody';
import CustomCard from 'components/card/CustomCard';
import CustomCardHeader from 'components/card/CustomCardHeader';
import ComponentLoader from 'components/ComponentLoader';
import { ComponentNoData } from 'components/ComponentLoader';
import { ComponentError } from 'components/ComponentLoader';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, XAxis, YAxis, Tooltip
} from 'recharts';
import { tryGetPredictionResult } from 'redux/slices/predictionSlice';


const PredictionResult = () => {
  const { campaign_id } = useParams()
  const dispatch = useDispatch()

  const {
    result: { data, loading, error, init }
  } = useSelector((state) => state.prediction)

  const colorPalette = [
    '#1f77b4',
    '#ff7f0e',
    '#2ca02c',
    '#d62728',
    '#9467bd',
    '#8c564b',
    '#e377c2',
    '#7f7f7f',
    '#bcbd22',
    '#17becf',
    '#aec7e8',
    '#ffbb78',
    '#98df8a',
    '#ff9896',
    '#c5b0d5',
    '#c49c94',
    '#f7b6d2',
    '#c7c7c7',
    '#dbdb8d',
    '#9edae5'
  ];


  useEffect(() => {
    dispatch(tryGetPredictionResult(campaign_id))
  }, [])

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="border-red-200 p-5">
          <p className="font-bold">{data.nominee_name}</p>
          <p className="desc">Vote Received: {data.vote_count}</p>
        </div>
      );
    }
    return null;
  };
  return <div className="h-auto px-3 -mt-24 md:px-8">
    <div className="container max-w-full mx-auto">
      <div className="px-4 mb-16 grid grid-cols-1">
        <CustomCard>
          <CustomCardHeader contentPosition="none">
            <div className="flex items-center justify-between w-full">
              <h2 className="text-2xl text-white">Results</h2>
            </div>
          </CustomCardHeader>
          <CardBody>
            {error ?
              <ComponentError errorMsg={error} />
              : loading ?
                <ComponentLoader />
                : isEmpty(data) && init ?
                  <ComponentNoData />
                  :
                  data?.map((r, index) => {
                    const withColor = r.result.map((x, i) => ({ ...x, fill: colorPalette[i] }));
                    return <div className="flex flex-col space-x-5 text-center mb-10" key={`prediction-result-${index}`}>
                      <h2 className="font-bold text-lg">{r.category_name}</h2>
                      <ResponsiveContainer height={500} width="100%" key={`Prediction-${index}`}>
                        <BarChart
                          data={withColor}
                          margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="candidate_name" />
                          <YAxis />
                          <Legend />
                          <Bar dataKey="vote_count" name="Vote Count" barSize={40} legendType="none" />
                          <Tooltip content={<CustomTooltip />}
                            cursor={{ stroke: 'transparent', fillOpacity: 0.4 }}
                          />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  }
                  )}
          </CardBody>
        </CustomCard>
      </div>
    </div>
  </div>
}


export default PredictionResult;

